export default "__VITE_ASSET__BJfDuYHZ__"